import { createRouter, createWebHistory } from 'vue-router'
import Home from './components/Home.vue'
import LogOff from "./components/login/LogOff.vue";
import Callback from './components/login/Callback.vue'
import { vuexOidcCreateRouterMiddleware } from 'vuex-oidc';
import Error from "./components/Error.vue";
import Unauthorizederror from "./components/Unauthorizederror.vue";
import store from './store';

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
      },
      {
          path: '/logoff',
          name: 'logoff',
          component: LogOff,
          meta: {
              isPublic: true
          }
      },
    {
      path: '/callback', // Needs to match redirect_uri in you oidcSettings
      name: 'callback',
      component: Callback,
      meta: {
        isOidcCallback: true,
        isPublic: true
      }
    },
      {
          path: '/error',
          name: 'error',
          component: Error,
          meta: {
              showModal: false,
              isPublic: true
          }
      },
      {
          path: '/unauthorize',
          name: 'unauthorizederror',
          component: Unauthorizederror,
          meta: {
              showModal: false,
              isPublic: true
          }
      }
  ]
})

router.beforeEach(vuexOidcCreateRouterMiddleware(store, 'oidcStore'))

export default router